module.exports = __webpack_public_path__ + "static/media/Hoist_ios_3_preview.9dec4518.jpg";